import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategorySection() {
  const { t } = useTranslation();
  const [query, setQuery] = useState("");

  const filtered = categories.filter((c) =>
    t(`categories.${c.key}`).toLowerCase().includes(query.toLowerCase())
  );

  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("categories.title")}
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600">
              {t("categories.subtitle")}
            </p>
          </div>
          <div className="relative w-full md:w-72">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t("search.placeholder")}
              className="w-full rounded-full border border-background-300/60 bg-background-50 py-2.5 pl-9 pr-4 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 focus:border-primary-400"
            />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {filtered.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 cursor-pointer transition-colors"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-48">
                <img
                  src={c.image}
                  alt={`${t(`categories.${c.key}`)} Basetao Spreadsheet`}
                  title={`${t(`categories.${c.key}`)} Basetao Spreadsheet category`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 p-4">
                <span className="truncate text-sm font-semibold text-foreground-900">
                  {t(`categories.${c.key}`)}
                </span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            {t("categories.empty")}
          </p>
        )}
      </div>
    </section>
  );
}